import React from 'react';
import CsvFilesManager from './components/CsvFilesManager';
import { Container } from '@/components/ui';
import { withPermissions } from '@/components/withPermissions';
import { PERMISSIONS } from '@/types/permissions';

const CsvImporter: React.FC = () => {
  return (
    <Container pt="2" pb="2" size="expand" className="csv-importer-page">
      <CsvFilesManager />
    </Container>
  );
};

export const CsvImporterPage = withPermissions(CsvImporter, {
  requiredPermissions: [PERMISSIONS.CSV_ACCESS],
  showRoleSwitcher: true,
});

export default CsvImporterPage;
